import { MNSproCloudApi } from '..';
import { BildungsloginRegistration } from '../api/v2';

export class BildungsloginService {
  private constructor() {}

  private static getApi(authToken: string) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    return MNSproCloudApi.V2.BildungsloginApiFactory(config);
  }

  /**
   * Checks the registration status.
   *
   * The response also contains the url of the registration process hosted by
   * "Bildungslogin", which is available before the tenant is registered.
   */
  public static async getRegistration(
    authToken: string,
    organizationId: string,
  ): Promise<BildungsloginRegistration> {
    const api = BildungsloginService.getApi(authToken);

    const result = await api.getRegistration(organizationId, {
      validateStatus: (status: number) => {
        return (
          (status >= 200 && status <= 299) || status === 404 || status === 403
        );
      },
    });

    if (result.status === 404 || result.status === 403) {
      // 404 = tenant has not applied for registration yet
      return {};
    }

    return result.data;
  }

  /**
   * Registers the tenant for the Bildungslogin service by storing the user's
   * confirmation of the redirection to "Bildungslogin", where the usage
   * agreement is concluded directly with BILDUNGSLOGIN GmbH.
   */
  public static async create(
    authToken: string,
    organizationId: string,
  ): Promise<BildungsloginRegistration> {
    const api = BildungsloginService.getApi(authToken);
    const result = await api.createRegistration(organizationId);

    return result.data;
  }
}
